export var TagType;

(function (TagType) {
  TagType["Default"] = "default";
  TagType["Custom"] = "custom";
})(TagType || (TagType = {}));